module.exports = __webpack_public_path__ + "img/advantage-3.8dd6914f.png";